// version: 1.0.7

const calculator = {
    output: null,
    rules: [],
    output_values: [
        {
            value: "correct",
            label: "Goed",
            color: "success",
        },
        {
            value: "incorrect",
            label: "Fout",
            color: "danger",
        },
        {
            value: "inconclusive",
            label: "Niet te meten",
            color: "medium",
        },
        {
            value: "reserve",
            label: "Reserve",
            color: "medium",
        },
        {
            value: "inactive",
            label: "Inactief",
            color: "medium",
        }
    ],
    resultLabel(result) {
        let result_row = calculator.output_values.find((row) => row.value == result);

        if (result_row) {
            return result_row.label;
        }

        return "Kon niet berekenen";
    },
    resultColor(result) {
        let result_row = calculator.output_values.find((row) => row.value == result);

        if (result_row) {
            return result_row.color;
        }

        return "Kon niet berekenen";
    },
    calculate(rules) {
        calculator.rules = rules;
        calculator.fieldRulesCalculate();

        if (calculator.rules.set_manually) {
            console.log("not calculating because set manually");
            if (!calculator.rules.result) {
                calculator.rules.result = "inconclusive";
            }
            calculator.rules.result_label = this.resultLabel(calculator.rules.result);
            calculator.rules.result_color = this.resultColor(calculator.rules.result);
            return calculator.rules;
        }

        if (rules.conditional_statements[0].data.length == 0) {
            console.log("not calculating because no conditional statements are present");
            if (!calculator.rules.result) {
                calculator.rules.result = "inconclusive";
            }
            calculator.rules.set_manually = true;
            calculator.rules.result_label = this.resultLabel(calculator.rules.result);
            calculator.rules.result_color = this.resultColor(calculator.rules.result);
            return calculator.rules;
        }

        console.log("calculating");
        let clauses = [];

        for (let row of calculator.rules.conditional_statements) {
            if (row.value == "if" || row.value == "or") {
                clauses.push({
                    value: row.value,
                    result: calculator.determine(row),
                });
            } else if (row.value == "and") {
                if (clauses[clauses.length - 1].result) {
                    clauses[clauses.length - 1].result = calculator.determine(row);
                }
            }
        }

        let result = false;

        for (let clause of clauses) {
            if (clause.result === true) {
                result = true;
                break;
            }
        }

        calculator.setResult(result);

        return calculator.rules;
    },
    setResult(result) {
        if (result) {
            calculator.rules.result = "correct";
        } else {
            calculator.rules.result = "incorrect";
        }
        calculator.rules.result_label = this.resultLabel(calculator.rules.result);
        calculator.rules.result_color = this.resultColor(calculator.rules.result);
    },
    determine(row) {
        let truthy;
        let first_3_rows = row.data.slice(0, 3);
        let except_first_3_rows = row.data.slice(3);

        const chunkSize = 2;
        const arr = except_first_3_rows;
        const groups = arr
            .map((e, i) => {
                return i % chunkSize === 0 ? arr.slice(i, i + chunkSize) : null;
            })
            .filter((e) => {
                return e;
            });

        truthy = calculator.calculateFormula(first_3_rows[0], first_3_rows[1], first_3_rows[2]);

        groups.forEach((row) => {
            if (row.length == 2) {
                let row_1 = {
                    type: "value",
                    value: truthy,
                };

                truthy = calculator.calculateFormula(row_1, row[0], row[1]);
            } else {
                truthy = "Onjuiste formule";
            }
        });

        return truthy;
    },
    calculateFormula(first, operator, last) {
        let computation;

        if (!first || !last) {
            return;
        }

        if ((first.type != "boolean" && !first.value) || (last.type != "boolean" && !last.value)) {
            return;
        }

        if (first.type == "field") {
            first = calculator.rules.fields.find((field) => field.uuid == first.value);

            if (!first) {
                return;
            }
        }

        if (last.type == "field") {
            last = calculator.rules.fields.find((field) => field.uuid == last.value);

            if (!last) {
                return;
            }
        }

        let first_value = calculator.parseValue(first.type, first.value);
        let last_value = calculator.parseValue(last.type, last.value);

        switch (operator.value) {
            case "+":
                computation = first_value + last_value;
                break;
            case "-":
                computation = first_value - last_value;
                break;
            case "*":
                computation = first_value * last_value;
                break;
            case "÷":
                computation = first_value / last_value;
                break;
            case "<":
                computation = first_value < last_value;
                break;
            case "<=":
                computation = first_value <= last_value;
                break;
            case ">":
                computation = first_value > last_value;
                break;
            case ">=":
                computation = first_value >= last_value;
                break;
            case "=":
                computation = first_value == last_value;
                break;
            case "!=":
                computation = first_value != last_value;
                break;
            default:
                return null;
        }

        return computation;
    },
    fieldRulesCalculate() {
        calculator.rules.fields.forEach((field) => {
            if (field.rules && field.rules.length > 0 && field.manual_override == false) {
                let rules_clauses = field.rules.reduce((acc, rule) => {
                    if (!acc[rule.clause_uuid]) {
                        acc[rule.clause_uuid] = [];
                    }
                    acc[rule.clause_uuid].push(rule);
                    return acc;
                }, {});

                let rules_clauses_keys = Object.keys(rules_clauses);
                let no_clauses_valid = true;

                rules_clauses_keys.forEach((rules_clauses_key) => {
                    let clause_valid = true;
                    rules_clauses[rules_clauses_key].forEach((field_rule) => {
                        let external_field = calculator.rules.fields.find(
                            (external_field_f) =>
                                external_field_f.uuid == field_rule.external_field_uuid
                        );

                        if (
                            external_field &&
                            external_field.uuid == field_rule.external_field_uuid
                        ) {
                            // Parse the external field value and rule value
                            const parsedExternalValue = calculator.parseValue(
                                external_field.type,
                                external_field.value
                            );
                            const parsedRuleValue = calculator.parseValue(
                                external_field.type,
                                field_rule.external_value
                            );

                            if (parsedExternalValue !== parsedRuleValue) {
                                clause_valid = false;
                            }
                        }
                    });

                    if (clause_valid) {
                        no_clauses_valid = false;
                        let then_rule = rules_clauses[rules_clauses_key].find(
                            (field_rule) => field_rule.clause == "then"
                        );
                        if (then_rule && then_rule.value && !field.manual_override) {
                            if (then_rule.value.includes("{{")) {
                                field.value = calculator.parseFormula(then_rule.value);
                            } else {
                                field.value = then_rule.value;
                            }
                        }
                    }
                });

                if (no_clauses_valid) {
                    field.value = null;
                }
            }
        });
    },
    parseFormula(formula) {
        const fields = calculator.rules.fields;

        const fieldValues = fields.reduce((obj, field) => {
            obj[field.label] = field.value;
            return obj;
        }, {});

        const numberRegex = /-?\d+(?:,\d+)?/g;
        const fieldLabelRegex = /In\([A-Z]\)/g;
        const operatorRegex = /[-+x/]/g;

        const matches = formula.match(numberRegex);
        if (matches.length !== 1) {
            throw new Error("Invalid formula: must contain exactly one numeric value");
        }

        const [leftValue, operator, rightValue] = formula
            .match(
                new RegExp(
                    `(${numberRegex.source})|(${fieldLabelRegex.source})|(${operatorRegex.source})`,
                    "g"
                )
            )
            .map((match) => match.trim());

        const isLeftNumber = numberRegex.test(leftValue);
        const isRightNumber = numberRegex.test(rightValue);

        if (isLeftNumber && isRightNumber) {
            throw new Error("Invalid formula: must contain a numeric value and a field label");
        }

        let leftNumber;
        if (isLeftNumber) {
            leftNumber = leftValue.includes(",")
                ? parseFloat(leftValue.replace(",", "."))
                : parseInt(leftValue);
        } else {
            leftNumber = fieldValues[leftValue].includes(",")
                ? parseFloat(fieldValues[leftValue].replace(",", "."))
                : parseInt(fieldValues[leftValue]);
        }

        let rightNumber;
        if (isRightNumber) {
            rightNumber = rightValue.includes(",")
                ? parseFloat(rightValue.replace(",", "."))
                : parseInt(rightValue);
        } else {
            rightNumber =
                fieldValues[rightValue] && fieldValues[rightValue].includes(",")
                    ? parseFloat(fieldValues[rightValue].replace(",", "."))
                    : parseInt(fieldValues[rightValue]);
        }

        switch (operator) {
            case "+":
                return leftNumber + rightNumber;
            case "-":
                return leftNumber - rightNumber;
            case "x":
                return leftNumber * rightNumber;
            case "/":
                return leftNumber / rightNumber;
            default:
                throw new Error("Invalid formula: must contain one of the operators -, +, x, /");
        }
    },
    parseValue(type, value) {
        if (typeof value === "string" && value.includes(",")) {
            value = value.replace(",", ".");
        }
        if (type == "float") {
            const parsedFloat = parseFloat(value);
            return parsedFloat;
        }
        if (type == "integer") {
            const parsedInt = parseInt(value);
            return parsedInt;
        }
        if (type == "boolean") {
            // Handle actual boolean values
            if (typeof value === "boolean") {
                return value;
            }
            
            // Handle string representations
            if (typeof value === "string") {
                const lowerValue = value.toLowerCase();
                return lowerValue === "true" || lowerValue === "on" || lowerValue === "yes" || lowerValue === "1";
            }
            
            // Handle numeric values
            if (typeof value === "number") {
                return value !== 0;
            }
            
            // Default to false for other cases
            return false;
        }
        return value;
    },
};

export default calculator;